import { Box, Button, Typography } from "@mui/material";
// import ms1 from "../Images/signboards/ms1.jpeg";
// import ms2 from "../Images/signboards/ms2.jpeg";
// import ms3 from "../Images/signboards/ms3.jpeg";
import companyLogo from "../Images/mudra-signs-logo.png";

// import MainHeaderComponent from "../components/HeadComp/MainHeaderComponent";
import { useNavigate } from "react-router-dom";

const imgLengthStyle = {
    maxWidth: { xs: "200px", sm: "300px", md: "400px" },
    minWidth: { xs: "100px", sm: "200px", md: "300px" },
    maxHeight: { xs: "200px", sm: "300px", md: "400px" },
    m: 1
}
const HomeLayout = () => {
    const nav = useNavigate();
    return (
        <Box sx={{
            height: "90vh",
            width: "100vw",
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"
        }}>
            {/* <MainHeaderComponent />

            <Box
                sx={{ height: "10vh" }}
            ></Box>
             */}
            <Box component="img"
                alt="Company Logo"
                src={companyLogo}
                sx={{
                    width: "200px",
                    // ml: 2,
                    // cursor: "pointer",
                }}
            // onClick={() => nav('/')}
            />
            <Box p={2} />
            <Box sx={{
            width: {xs:"90%", sm:"60%", md:"30%"},
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"
        }}>

                <Button variant="contained"
                    fullWidth
                    onClick={() => nav("/request")}>Raise Complaint / Request</Button>
                <Box p={2} />
                <Button variant="contained"
                    fullWidth
                    onClick={() => nav("/my_status")}>Application Status</Button>
            </Box>
            {/* <Typography sx={{ textAlign: "center", fontWeight: "bold", fontSize: { md: "2rem" }, 
            // color:"#2e318f" 
            }}>Our works</Typography>
            <Box sx={{
                // height: { md: "calc(100vh - 20vh)" },
                width: "100vw",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                justifyContent: "center"
            }}>

                <Box component="img"
                    src={ms1}
                    alt="ms1"
                    sx={imgLengthStyle}
                />

                <Box component="img"
                    src={ms2}
                    alt="ms2"
                    sx={imgLengthStyle}
                />
                <Box component="img"
                    src={ms3}
                    alt="ms3"
                    sx={imgLengthStyle}
                />
            </Box> */}

        </Box>
    )
}
export default HomeLayout;